{
  "dismiss": "Lukk"
}